// Cross-cutting fields that must never end up in a persisted draft regardless
// of form shape: payment instruments, auth tokens, government IDs, raw
// insurance/identity numbers. scrub() matches by key name only — a sensitive
// value stored under a neutral key (e.g. `note: 'SSN 123...'`) is NOT
// stripped; rely on form-level allow-listing for those cases.
export const DRAFT_DENY_KEYS = new Set([
  'cardNumber',
  'card_number',
  'cvv',
  'cvc',
  'password',
  'ssn',
  'driversLicense',
  'drivers_license',
  'govIdNumber',
  'gov_id_number',
  'payrocSessionToken',
  'payrocNonce',
  'member_id',
  'memberId',
  'group_number',
  'groupNumber',
  'policyNumber',
  'subscriberId',
  'payer_id',
  'insured_date_of_birth',
  'card_front',
  'card_back',
  'mrn'
]);

export const scrubDraftPayload = (value, denyKeys = DRAFT_DENY_KEYS) => {
  if (Array.isArray(value)) return value.map((v) => scrubDraftPayload(v, denyKeys));
  if (value && typeof value === 'object') {
    const out = {};
    for (const [k, v] of Object.entries(value)) {
      if (denyKeys.has(k)) continue;
      out[k] = scrubDraftPayload(v, denyKeys);
    }
    return out;
  }
  return value;
};
